<template>
  <div class="deposit">
    <div v-if="!isSuccess" class="deposit__content">
      <div class="deposit__title">
        {{ $t('deposit.title') }}
      </div>
      <div
        v-if="accountsListWithCampaigns && accountsListWithCampaigns.length"
        class="deposit__steps"
      >
        <DepositSource
          :selected-account="selectedAccount"
          :selected-pay-type="selectedPayType"
          @on-change="selectedPayType = $event"
        />
        <div class="deposit__step">
          <div class="deposit__step-title">2. {{ $t('deposit.list_of_ad_campaigns') }}</div>
          <div class="deposit__step-content">
            <div class="deposit__step-title--small">
              {{
                selectedAccount.min_deposit
                  ? `${$t('prepaid.min-payment')}  ${selectedAccount.min_deposit} ${
                      serviceCurrencyIcon[serviceCurrency]
                    }`
                  : null
              }}
            </div>
            <div class="deposit__step-row">
              <div class="deposit__step-col">
                <div
                  v-if="accountsListWithCampaigns && accountsListWithCampaigns.length"
                  class="deposit__step-account-selector"
                  ref="accountSelector"
                  :style="{ marginBottom: accountSelectorMarginBottom }"
                >
                  <div
                    v-if="selectedAccount"
                    class="deposit__step-account-selector-value"
                    @click="showCampaignsList"
                  >
                    <DepositIcons :service="selectedAccount.service" />
                    <span class="deposit__step-account-selector-info">
                      <span
                        v-if="selectedAccount.description"
                        class="deposit__step-account-selector-desc"
                        v-html="selectedAccount.description"
                      />
                      <span class="deposit__step-account-selector-title">
                        {{ selectedAccount ? selectedAccount.account_name : '' }}
                      </span>
                      <img
                        class="deposit__step-account-selector-arrow"
                        :class="{ active: showOptions }"
                        src="@/assets/icons/icon-arrow.svg"
                        alt="arrow"
                      />
                    </span>
                  </div>
                  <div
                    v-show="showOptions"
                    ref="accountSelectorOptions"
                    class="deposit__step-account-selector-options"
                  >
                    <div
                      class="form-input deposit__step-account-selector-search"
                      :class="[{ 'form-input--full': search }]"
                    >
                      <input v-model="search" type="text" required />
                      <span class="form-input__label">
                        {{ $t('search_props.placeholder') }}
                      </span>
                    </div>
                    <div
                      v-for="item in filtredAccountsList"
                      :key="item.id"
                      class="deposit__step-account-selector-item"
                      @click="selecteAccount(item)"
                    >
                      <span class="deposit__step-account-selector-service">
                        <!-- {{ item.service }} -->
                        <img :src="getLogo(item.service)" alt="add account logo" />
                      </span>
                      <span class="deposit__step-account-selector-info">
                        <span
                          v-if="item.description"
                          class="deposit__step-account-selector-desc"
                          v-html="item.description"
                        />
                        <span class="deposit__step-account-selector-title">
                          {{ item.account_name }}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="deposit__step-col">
                <DepositAmount
                  :account-name="selectedAccount ? selectedAccount.account_name : ''"
                  :currency="selectedAccount ? selectedAccount.service_currency : ''"
                  default-value="0"
                  :isCurrencyChange="isCurrencyChange"
                  :addAccount="selectedAccount ? selectedAccount.service : ''"
                />
                <div
                  v-if="selectedAccount && selectedAccount.service !== 'google'"
                  class="deposit__advt-tax-checkbox"
                >
                  <label class="deposit__advt-tax-checkbox-label">
                    <input
                      type="checkbox"
                      v-model="includesAdvtTax"
                      class="deposit__advt-tax-checkbox-input"
                    />
                    <span class="deposit__advt-tax-checkbox-text"
                      >Сумма включает рекламный сбор</span
                    >
                  </label>
                </div>
              </div>
            </div>
            <button
              v-loading="isFetchingCompanies"
              @click="showCompaniesList = !showCompaniesList"
              class="deposit__toggle-show-list-companies-btn"
            >
              <span>Выбрать рекламные кампании для пополнения</span>
              <img
                class="deposit__toggle-show-list-companies-btn-icon"
                :class="{ open: showCompaniesList }"
                src="@/assets/icons/icon-arrow.svg"
                alt="arrow"
              />
            </button>

            <DepositCampaign
              v-if="showCompaniesList && campaignList && campaignList.length"
              :list="campaignList"
              :currency="selectedAccount ? selectedAccount.service_currency : ''"
              :addAccount="selectedAccount ? selectedAccount.service : ''"
              class="deposit__companies-list"
            />
            <div v-else-if="showCompaniesList && !isFetchingCompanies">
              {{ $t('deposit.no_match') }}
            </div>
            <div v-if="error && error.length" class="deposit__step-account-selector-error">
              <span v-for="(err, key) in error" :key="key + 'err'"> {{ err }} <br /> </span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="deposit__step-none">
        {{ $t('deposit.no_ad_accounts_to') }}
      </div>
    </div>
    <div
      v-if="!campaignList.length"
      class="deposit_buffer"
      :style="{ 'min-height': campaignsHeight }"
    ></div>
    <DepositPromoCode
      v-if="!isSuccess && role !== 'partner'"
      ref="depositPromoCode"
      :button-disabled="buttonDisabled"
      @apply-promo="handleApplyPromo"
    />
    <div v-if="!isSuccess" class="deposit__final">
      <DepositSummary
        :selected-campaigns="selectedCampaigns"
        :account-amount="accountAmount"
        :selected-account="selectedAccount"
        :active-account="activeAccount"
        :currency-rates="currencyRates"
        :includes-advt-tax="includesAdvtTax"
      />
      <ButtonElement
        :text="$t('button_props.top_up')"
        :disabled="getButtonState"
        @click-button="transferAmount"
      />
    </div>
    <div v-if="isSuccess" class="deposit__success">
      <img
        class="deposit__success-icon"
        src="../../assets/icons/icon-success.svg"
        alt="success icon"
      />
      <div class="deposit__success-title">
        {{ $t('deposit.payment_credited') }}
      </div>
      <div class="deposit__success-desc">
        {{ $t('deposit.replenished_amount') }} {{ numberWithSpacesFix2(totalAmount) }}
        {{ $t('currency.currency_symbol') }}
      </div>
      <div class="deposit__success-button">
        <ButtonElement :text="$t('button_props.excellent')" @click-button="close" />
      </div>
    </div>
  </div>
</template>

<script>
import DepositCampaign from '@/components/ad/DepositCampaign';
import DepositAmount from '@/components/ad/DepositAmount';
import ButtonElement from '@/components/elements/ButtonElement';
import axios from 'axios';
import numberWithSpaces from '@/mixin/numberWithSpaces';
import numberWithSpacesFix2 from '@/mixin/numberWithSpaces';
import checkCashback from '@/mixin/checkCashback';
import DepositIcons from './DepositIcons.vue';
import DepositSource from './DepositSource.vue';
import DepositSummary from '../forms/DepositSummary.vue';
import DepositPromoCode from '../forms/DepositPromoCode.vue';
import { useLogo } from '../../mixin';
import { calculateDepositTotals } from '@/utils/forms/depositCalculations';
import { isRemovedPlatform } from '@/utils/services';
import { SITE_SETTINGS_STORE } from '../../store';
import { reachCabinetCompletedGoal } from '@/utils/metrika';

export default {
  name: 'Deposit',
  components: {
    DepositCampaign,
    DepositAmount,
    ButtonElement,
    DepositIcons,
    DepositSource,
    DepositSummary,
    DepositPromoCode,
  },
  mixins: [numberWithSpaces, checkCashback, numberWithSpacesFix2, useLogo],
  data() {
    return {
      isFetchingCompanies: false,
      showCompaniesList: false,
      buttonDisabled: false,
      promosSuccess: false,
      campaignsHeight: 0,
      selectedPayType: 'balance',
      isDepositDialog: false,
      selectedAccount: null,
      showOptions: false,
      isSuccess: false,
      totalAmount: null,
      accountsListWithCampaigns: [],
      error: [],
      campaignList: [],
      disabledButton: false,
      currentCurrency: 'RUB',
      promo: {
        description:
          'Данный промокод начисляет дополнительные 1000 руб. на счет кэшбека сразу после активации. Промосумма может быть использована только для пополнения бюджета рекламных площадок и доступна в течение 12 месяцев после активации промокода. Вывод промосуммы на расчетный счет – невозможен.',
        expired_at: '15.09.2023',
      },
      serviceCurrencyIcon: {
        RUB: '₽',
        USD: '$',
        PLN: 'zł',
        EUR: '€',
      },
      search: '',
      selectorOptionsHeight: 0,
      form: {
        promo_code: '',
      },
      errors: {
        promo_code: '',
      },
      includesAdvtTax: false, // Флаг: включает ли введенная сумма рекламный сбор
    };
  },
  computed: {
    formPromo() {
      return this.form.promo_code;
    },
    activePlatformSlug() {
      return (this.$route && this.$route.query && this.$route.query.platform) || null;
    },
    getCurrentPlatformName() {
      const query = { ...this.$route.query };
      return this.selectedAccount ? this.selectedAccount.service : query.platform;
    },
    vat() {
      return this.$store.getters[SITE_SETTINGS_STORE.GETTERS.GET_VAT];
    },
    isCurrencyChange() {
      return this.selectedAccount.service === 'google' ? false : true;
    },
    activeAccount() {
      return this.$store.state.Auth.activeAccount;
    },
    accountsList() {
      return this.$store.state.Ad.accountsList;
    },
    depositAmount() {
      return this.$store.state.Balance.depositAmount;
    },
    selectedCampaigns() {
      return this.$store.getters['Balance/selectedCampaigns'];
    },
    depositTotals() {
      if (!this.selectedAccount || !this.activeAccount) {
        return null;
      }
      return calculateDepositTotals({
        selectedCampaigns: this.selectedCampaigns,
        accountAmount: this.accountAmount,
        selectedAccount: this.selectedAccount,
        activeAccount: this.activeAccount,
        currencyRates: this.currencyRates,
        vat: this.vat,
        includesAdvtTax: this.includesAdvtTax,
      });
    },
    finalAmount() {
      return this.depositTotals?.finalAmount || 0;
    },
    baseDepositAmount() {
      return this.depositTotals?.baseDepositAmount || 0;
    },
    baseDepositAmountExact() {
      return this.depositTotals?.baseDepositAmountExact || 0;
    },
    finalAmountWithCommission() {
      return this.depositTotals?.amountWithCommission || 0;
    },
    totalNds() {
      return this.depositTotals?.nds || 0;
    },
    finalAmountWithAdvtTax() {
      return this.depositTotals?.finalAmountWithAdvtTax || 0;
    },
    advtTaxAmount() {
      return this.depositTotals?.advtTaxAmount || 0;
    },
    totalWithAdvtTax() {
      return this.depositTotals?.totalWithAdvtTax || 0;
    },
    totalSum() {
      return this.depositTotals?.totalSum || 0;
    },
    amountForAccount() {
      return this.$store.state.Balance.account;
    },
    accountAmount() {
      return this.$store.state.Balance.account || 0;
    },
    currencyRates() {
      return this.$store.state.Auth.currencyRates || [];
    },
    currentCommission() {
      return this.depositTotals?.commissionPercent || 0;
    },
    role() {
      return this.$store.state.Auth.role;
    },
    serviceCurrency() {
      return this.selectedAccount.service_currency;
    },
    courcePercent() {
      return this.activeAccount.course_percents[this.selectedAccount.service_currency];
    },
    currentRate() {
      return this.depositTotals?.currencyRate || 1;
    },
    plnRate() {
      if (this.localCurrency !== this.serviceCurrency && this.serviceCurrency === 'PLN') {
        const rate = this.currencyRates.find(
          (el) => el.to === this.serviceCurrency && el.from === this.localCurrency
        );
        if (rate && this.courcePercent) {
          return rate.value / (1 + this.courcePercent / 100);
        } else if (rate) {
          return rate.value;
        } else {
          return 1;
        }
      }
      return 1;
    },
    filtredAccountsList() {
      const accounts = Array.isArray(this.accountsListWithCampaigns)
        ? [...this.accountsListWithCampaigns]
        : [];
      // Фильтруем по статусу: только active или archive (как в AccountCard)
      let filtered = accounts.filter((el) => el.status === 'active' || el.status === 'archive');

      const filledAccount = this.$store.state.Balance.filledAccount;
      if (filledAccount && filledAccount.status) {
        // Проверяем, что filledAccount имеет допустимый статус для пополнения
        const isValidStatus =
          filledAccount.status === 'active' || filledAccount.status === 'archive';
        if (isValidStatus) {
          // Фильтруем по статусу filledAccount
          filtered = filtered.filter((el) => el.status === filledAccount.status);
          const hasFilledAccount = filtered.some((el) => el.id === filledAccount.id);
          if (!hasFilledAccount) {
            filtered = [filledAccount, ...filtered];
          }
        }
      }

      if (this.search) {
        const query = this.search.toLowerCase();
        filtered = filtered.filter(
          (el) =>
            (el.description && el.description.toLowerCase().includes(query)) ||
            (el.account_name && el.account_name.toLowerCase().includes(query))
        );
      }

      return filtered;
    },
    getTotal() {
      return this.depositTotals?.totalWithRate || 0;
    },
    getButtonState() {
      return (
        !this.finalAmount ||
        this.disabledButton ||
        Number(this.getTotal.toFixed(2)) < this.minPaymentAmount
      );
    },
    errorMessage() {
      return this.$store.state.promo.errors;
    },
    minPaymentAmount() {
      const minPayment = this.selectedAccount.min_deposit || 0;
      return minPayment;
    },
    localCurrency() {
      return 'RUB'; // Только RU версия
    },
    accountSelectorMarginBottom() {
      const baseMargin = 14;
      return `${baseMargin + this.selectorOptionsHeight}px`;
    },
    platformsList() {
      return this.$store.state.Ad.platformsList || [];
    },
    user() {
      return this.$store.state.Auth.user;
    },
  },
  watch: {
    showCompaniesList(val) {
      if (val && !this.campaignList.length) {
        this.fetchCompanies(this.role !== 'partner');
      }
    },
    depositAmount: {
      deep: true,
      handler() {
        this.error = [];
      },
    },
    formPromo() {
      this.checkPromo();
    },
    amountForAccount() {
      this.error = [];
    },
    showOptions(val) {
      if (val) {
        this.campaignsHeight = '30rem';
        this.scheduleSelectorSpacingUpdate();
      } else {
        this.campaignsHeight = 0;
        this.selectorOptionsHeight = 0;
      }
    },
    search() {
      if (this.showOptions) {
        this.scheduleSelectorSpacingUpdate();
      }
    },
    filtredAccountsList() {
      if (this.showOptions) {
        this.scheduleSelectorSpacingUpdate();
      }
    },
  },
  created() {
    this.$store.dispatch('Auth/getCurrencyRates', { business_account_id: this.activeAccount.id });
    this.$store.dispatch(SITE_SETTINGS_STORE.ACTIONS.FETCH_VAT);
  },
  mounted() {
    if (this.activeAccount) {
      const isPartner = this.role === 'partner';
      this.fetchActiveAccounts(isPartner);
    }

    document.addEventListener(
      'click',
      (e) => {
        if (!e.target.closest('.deposit__step-account-selector')) {
          this.showOptions = false;
        }
      },
      true
    );
  },
  methods: {
    validatePromo(value) {
      let regex = /[а-яА-ЯёЁ\W]+/;
      return regex.test(value);
    },

    checkPromo() {
      if (!this.form.promo_code) this.errors.promo_code = '';
      else if (this.form.promo_code.length < 6 || this.form.promo_code.length > 10)
        this.errors.promo_code = this.$t('prepaid.promo-length-error');
      else if (this.validatePromo(this.form.promo_code))
        this.errors.promo_code = this.$t('prepaid.promo-value-error');
      else this.errors.promo_code = '';
    },

    sendPromo() {
      const data = {
        id: this.activeAccount.id,
        promo: { code: this.form.promo_code },
        token: localStorage.getItem('token') || localStorage.getItem('client_token'),
      };
      this.$store
        .dispatch('promo/applyPromo', data)
        .then((response) => {
          this.promo.description = response.data.data.description;
          this.promo.expired_at = response.data.data.expired_at;
          this.promosSuccess = true;
        })
        .catch((error) => {
          this.errors.promo_code = this.errorMessage.code[0];
        });
    },
    handleApplyPromo(promoCode) {
      const data = {
        id: this.activeAccount.id,
        promo: { code: promoCode },
        token: localStorage.getItem('token') || localStorage.getItem('client_token'),
      };
      this.$store
        .dispatch('promo/applyPromo', data)
        .then((response) => {
          if (this.$refs.depositPromoCode) {
            this.$refs.depositPromoCode.handleSuccess(response.data.data);
          }
        })
        .catch((error) => {
          let errorMessage = '';
          if (error.response && error.response.data && error.response.data.errors) {
            errorMessage = error.response.data.errors.code
              ? error.response.data.errors.code[0]
              : error.response.data.errors;
          } else {
            errorMessage = error.message || this.$t('prepaid.promo_error');
          }
          if (this.$refs.depositPromoCode) {
            this.$refs.depositPromoCode.handleError(errorMessage);
          }
        });
    },

    showCampaignsList() {
      this.showOptions = !this.showOptions;
    },
    scheduleSelectorSpacingUpdate() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const optionsEl = this.$refs.accountSelectorOptions;
          if (!optionsEl || !this.showOptions) {
            this.selectorOptionsHeight = 0;
            return;
          }
          this.selectorOptionsHeight = optionsEl.offsetHeight + 5;
        });
      });
    },

    selecteAccount(item) {
      if (this.$refs.campaigns) this.$refs.campaigns.resetChosenCampaigns();
      this.$store.commit('Balance/setData', { label: 'chooseCampaign', data: null });
      this.selectedAccount = item;
      this.showOptions = false;
      this.campaignList = [];
      this.showCompaniesList = false;
      // Сбрасываем чекбокс при смене аккаунта
      this.includesAdvtTax = false;
    },
    async fetchCompanies(onlyUseAccountId = false) {
      this.isFetchingCompanies = true;

      this.$store
        .dispatch('Ad/getCampaigns', {
          ...(!onlyUseAccountId && { user_id: this.user.id }),
          ...(!onlyUseAccountId && { ba_id: this.activeAccount.id }),
          ...(!onlyUseAccountId && { service: this.selectedAccount.service }),
          account_id: this.selectedAccount.id,
        })
        .then((data) => {
          this.campaignList = data.data.data.filter(
            (el) => el.limit_type && el.limit_type !== 'lifetime'
          );
          this.isFetchingCompanies = false;
        });
    },
    transferAmount() {
      if (this.finalAmount < this.minPaymentAmount && (this.role === 'user' || this.role === '')) {
        this.error.push(`${this.$t('prepaid.validation_input.min')} 50`);
      } else {
        this.disabledButton = true;
        // Если чекбокс включен, отправляем базовую сумму (без рекламного сбора)
        // Бэкенд добавит рекламный сбор сверху
        // Если чекбокс выключен, отправляем базовую сумму (finalAmount)
        const totalSumToSend =
          this.includesAdvtTax && this.selectedAccount && this.selectedAccount.service !== 'google'
            ? this.baseDepositAmount // Базовая сумма уже включает аккаунт и кампании
            : this.finalAmount;
        const data = {
          service: this.selectedAccount.service,
          business_account_id: this.activeAccount.id,
          account_id: this.selectedAccount.id,
          total_sum: totalSumToSend,
          campaigns_amounts: this.selectedCampaigns,
          from_cashback: !(this.selectedPayType === 'balance'),
        };
        if (this.role === 'manager' || this.role === 'finance') {
          data.token = localStorage.getItem('token');
        }
        this.$store
          .dispatch('Balance/transferToCampaigns', data)
          .then(({ data }) => {
            if (data.success) {
              this.isSuccess = true;
              this.totalAmount = data.data.total;
              reachCabinetCompletedGoal(this, this.$store);
              this.$store.commit('Balance/setData', { label: 'chooseCampaign', data: null });
              this.$store.commit('Balance/setData', { label: 'depositAmount', data: [] });
              this.$store.commit('Balance/setData', { label: 'filledAccount', data: null });
              this.$store.commit('Balance/setData', { label: 'account', data: null });
            }
            this.disabledButton = false;
          })
          .catch((err) => {
            if (err.data.errors) {
              for (let key in err.data.errors) {
                err.data.errors[key].forEach((el) => {
                  this.error.push(el);
                });
              }
            }
            this.disabledButton = false;
          });
      }
    },
    fetchActiveAccounts(isPartner) {
      axios({
        url:
          process.env.VUE_APP_API_URL +
          `/advertservice/active-accounts-in-services?business_account_id=${this.activeAccount.id}&can_finance=1`,
        method: 'GET',
      }).then(({ data }) => {
        const activePlatform = this.activePlatformSlug;
        if (data.data) {
          for (let key in data.data) {
            if (key)
              this.accountsListWithCampaigns = this.accountsListWithCampaigns.concat(
                data.data[key]
              );
          }
          this.accountsListWithCampaigns = this.accountsListWithCampaigns
            .filter((el) => {
              if (isRemovedPlatform(el.service)) {
                return false;
              }
              // Фильтруем по статусу: только active или archive (как в AccountCard)
              if (el.status !== 'active' && el.status !== 'archive') {
                return false;
              }
              if (isPartner) {
                return (
                  this.activeAccount.services.includes(el.service) &&
                  (!activePlatform || el.service === activePlatform)
                );
              } else {
                return (
                  this.activeAccount.visible_services[el.service] &&
                  (!activePlatform || el.service === activePlatform)
                );
              }
            })
            .map((item) => {
              const platformItem = this.platformsList.find((unit) => unit.slug === item.service);
              const minDeposit = platformItem ? platformItem.min_deposit : 0;
              return { ...item, min_deposit: minDeposit };
            });
        }
        const filledAccount = this.$store.state.Balance.filledAccount;
        const fallbackList = isPartner ? this.filtredAccountsList : this.accountsListWithCampaigns;
        const fallbackAccount = filledAccount || fallbackList[0];
        if (fallbackAccount) {
          if (!fallbackAccount.min_deposit) {
            const account_item = this.platformsList.find(
              (unit) => unit.slug === fallbackAccount.service
            );
            this.selectedAccount = {
              ...fallbackAccount,
              min_deposit: account_item ? account_item.min_deposit : 0,
            };
          } else {
            this.selectedAccount = filledAccount ? filledAccount : fallbackList[0];
          }
        } else {
          this.selectedAccount = null;
        }
      });
    },
    close() {
      this.$store.dispatch('Dialog/closeDialog', () => window.location.reload(true));
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      return `${day}.${month}.${year}`;
    },
  },
  beforeDestroy() {
    this.$store.commit('Balance/setData', { label: 'chooseCampaign', data: null });
    this.$store.commit('Balance/setData', { label: 'depositAmount', data: [] });
    this.$store.commit('Balance/setData', { label: 'filledAccount', data: null });
    this.$store.commit('Balance/setData', { label: 'account', data: null });
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.deposit-promo {
  padding: 0 7rem 6rem 6rem;
  min-width: 50rem;
  width: 60%;

  .promo__success {
    font-weight: 400;
    font-size: 1.4rem;
    color: #7f858d;
    line-height: 16.41px;
    .promo_trial {
      color: #bfc2c6;
      font-weight: 400;
      font-size: 1.4rem;
      margin: 0.8rem 0 2.3rem 0;
    }
  }
  .prepaid__flex-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 1.2rem;
    width: 100%;

    .prepaid__success-icon {
      max-width: 21px;
      max-height: 21px;
      position: absolute;
      z-index: 0;
      right: 5%;
      top: 50%;
      transform: translateY(-50%);
    }
    .form-input {
      max-width: 50%;
      width: 100%;
      margin-bottom: 0;
    }
    .promo-button-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      max-width: 50%;
      width: 100%;
      height: 5rem;
      .submitted {
        color: #219653;
        font-size: 1.4rem;
        font-family: Roboto;
        font-weight: 400;
      }
      .button {
        height: 100%;
        width: 100%;
      }
    }
  }
}

.deposit {
  background: #fff;
  color: #000;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;

  &__companies-list {
    max-height: 1000px;
    overflow: auto;
    margin-top: 2rem;
  }

  &__toggle-show-list-companies-btn-icon {
    transition: transform 100ms ease;

    &.open {
      transform: rotate(180deg);
    }
  }

  &__toggle-show-list-companies-btn {
    display: flex;
    appearance: none;
    border: none;
    background: none;
    font-weight: 700;
    font-size: 16px;
    gap: 11px;
    margin-top: 2rem;
    text-align: left;

    @include below(1025px) {
      font-size: 14px;
    }
  }

  &__close {
    position: absolute;
    top: 2rem;
    right: 2rem;
    cursor: pointer;
  }

  &__title {
    font-weight: 700;
    font-size: 3rem;
    line-height: 3.5rem;
    margin-bottom: 5rem;
  }

  &__content {
    padding: 7rem 6rem;
  }

  &__final {
    width: 100%;
    background: #eff1f4;
    padding: 3.3rem 6rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: auto;

    &-block {
      width: 100%;
      padding-right: 4rem;
    }

    &-sum,
    &-nds,
    &-total {
      display: flex;
      align-items: center;
      margin-bottom: 1.5rem;

      &__title {
        font-size: 1.8rem;
        font-weight: 400;
        line-height: 2.2rem;
        color: $grey1;
        margin-right: 1rem;
      }

      &__value {
        font-size: 1.8rem;
        font-weight: 700;
        line-height: 2.1rem;
        color: $basicBlack;
      }
    }

    &-total {
      margin-top: 3.6rem;

      &__title {
        color: $basicBlack;
        margin-right: 2rem;
      }

      &__value {
        font-size: 3rem;
        line-height: 3.5rem;
      }
    }

    .button {
      width: 27rem;
      height: 4.5rem;
      border-radius: 6px;
    }
  }

  &__step {
    margin-bottom: 4.4rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    &-none {
      font-size: 1.8rem;
    }

    &-title {
      font-weight: 700;
      font-size: 2rem;
      line-height: 2.3rem;
      color: #333333;
      margin-bottom: 1.8rem;

      &--small {
        font-size: 1.8rem;
        line-height: 2.1rem;
        margin-bottom: 0.9rem;
      }
    }

    &-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      position: relative;
      &.add-x-scroll {
        overflow-x: auto;
        min-height: 55rem;
      }
    }

    &-subtitle {
      font-size: 1.6rem;
      line-height: 1.9rem;
      color: #7f858d;
      margin-bottom: 0.9rem;
    }

    &-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    &-col {
      margin-right: 2.4rem;

      &:last-of-type {
        margin-right: 0;
      }
    }

    &-account-selector {
      width: auto;
      min-width: 32.9rem;
      margin-bottom: 1.4rem;
      position: relative;

      &-value {
        border: 1px solid #d1d4d8;
        border-radius: 6px;
        height: 5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 5rem 0 1.5rem;
        cursor: pointer;
      }

      &-name {
        display: flex;
        align-items: center;
        font-weight: 700;
        text-align: right;

        & > img {
          margin-right: 0.5rem;
          width: 2rem;
          height: 2rem;
          display: block;
        }
      }

      &-arrow {
        position: absolute;
        right: 2rem;
        transition: 0.3s ease-out;
        top: calc(50% - 8px);

        &.active {
          transform: rotate(-180deg);
        }
      }

      &-options {
        position: absolute;
        border: 1px solid #bfc2c6;
        border-radius: 6px;
        background: #fff;
        z-index: 10;
        width: 100%;
        left: 0;
        top: calc(100% + 5px);
        max-height: 40rem;
        overflow-y: auto;
        padding: 0 2rem;
      }

      &-desc {
        font-size: 1.2rem;
        line-height: 1.4rem;
        color: #333333;
      }

      &-title {
        font-size: 1.4rem;
        line-height: 1.6rem;
        color: #7f858d;
        font-weight: 400;
      }

      &-item {
        height: 5.8rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: 0.3s ease-out;
        font-size: 1.4rem;
        border-bottom: 1px solid #edeff3;

        &:last-of-type {
          border-bottom: none;
        }

        &:hover {
          color: var(--primary);
        }
      }

      &-service {
        font-weight: 700;
        & > img {
          display: block;
          max-width: 2rem;
          width: 100%;
        }
      }

      &-info {
        text-align: right;
        display: flex;
        flex-direction: column;
      }

      &-error {
        color: $redLight;
        margin-top: 2rem;
      }

      &-search {
        margin: 10px 0;
      }
    }
  }

  &__success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    padding: 0 10rem;

    &-icon {
      margin-bottom: 2rem;
    }

    &-title {
      font-weight: 500;
      font-size: 4rem;
      line-height: 4.7rem;
      margin-bottom: 1.2rem;
    }

    &-desc {
      font-size: 2rem;
      line-height: 2.3rem;
      margin-bottom: 5rem;
    }

    &-button {
      .button {
        width: 27rem;
        height: 5rem;
      }
    }
  }

  &__rate {
    color: #7f858d;
    margin-top: -1.5rem;
  }
  &__balance-actualization {
    margin-top: 1rem;
  }
  &__advt-tax-checkbox {
    margin-top: 1rem;
    &-label {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 1.4rem;
      line-height: 1.6rem;
      color: #333333;
    }
    &-input {
      margin-right: 0.8rem;
      width: 1.6rem;
      height: 1.6rem;
      cursor: pointer;
    }
    &-text {
      user-select: none;
    }
  }
}

@include below(993px) {
  .deposit__final,
  .deposit__content {
    padding: 15px;
  }
  .deposit-promo {
    padding-left: 15px;
  }
}

@include below(769px) {
  .deposit-promo {
    padding: 0 3rem 6rem;
  }
  .deposit__step-row {
    width: 100%;
    grid-template-columns: 1fr;
    margin-bottom: 30px;
  }
  .deposit__step-col + .deposit__step-col {
    width: 100%;
  }
  .deposit__step-account-selector {
    min-width: 0;
    width: 100%;
    max-width: 400px;
  }
  .deposit__title {
    margin-right: 35px;
    font-size: 22px;
    line-height: 1.3;
    margin-bottom: 30px;
    word-break: break-word;
  }
  .deposit-campaign {
    padding: 15px;
  }
}

@include below(500px) {
  .deposit-promo {
    min-width: 40rem;
    width: 70%;
  }
  .deposit__balances {
    flex-wrap: wrap;
    width: 100%;
  }
  .deposit__balances-item {
    width: 100%;
    margin-right: 0;
    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }
  .deposit__final {
    flex-wrap: wrap;
    .button {
      width: 100%;
    }
  }
  .deposit__final-block {
    width: 100%;
    padding-right: 0;
    padding-bottom: 20px;
  }
}
</style>
